import { render, staticRenderFns } from "./alterar-endereco.vue?vue&type=template&id=dab73af8&"
import script from "./alterar-endereco.vue?vue&type=script&lang=js&"
export * from "./alterar-endereco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports